import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const LeftCol = styled.div`
  width: 60%;
`;

const RighttCol = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StatRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const StatLabel = styled(Typography)`
  width: 80%;
  max-width: 7.5rem;
`;

const StatValue = styled(Typography)`
  width: 20%;
  &&& {
    color: ${COLORS.black};
  }
`;

const SVG = styled.svg`
  height: 4.375rem;
`;

const ChartNumber = styled.text`
  fill: ${COLORS.black};
  font-size: 0.4rem;
  text-anchor: middle;
  transform: translateY(-${SIZES['2']});
`;

const ChartLabel = styled.text`
  fill: ${COLORS.darkerGrey};
  font-size: 0.35rem;
  text-anchor: middle;
  transform: translateY(${SIZES['4']});
`;

const MatchesPieChart = ({wins, defeats, draws}) => {
  const total = wins + defeats + draws;
  const wins_relative = Math.round((wins / total) * 100);
  const defeats_relative = Math.round((defeats / total) * 100);
  const wins_inverse = 100 - wins_relative;
  const defeats_inverse = 100 - defeats_relative;

  return (
    <Wrapper>
      <LeftCol>
        <StatRow>
          <StatLabel variant='caption1'>Siege</StatLabel>
          <StatValue variant='caption1'>{wins}</StatValue>
        </StatRow>
        <StatRow>
          <StatLabel variant='caption1'>Unentschieden</StatLabel>
          <StatValue variant='caption1'>{draws}</StatValue>
        </StatRow>
        <StatRow>
          <StatLabel variant='caption1'>Niederlagen</StatLabel>
          <StatValue variant='caption1'>{defeats}</StatValue>
        </StatRow>
      </LeftCol>
      <RighttCol>
        <SVG viewBox='0 0 34 34'>
          <circle cx='17' cy='17' r='16' fill={COLORS.white}></circle>
          <circle cx='17' cy='17' r='16' fill='transparent' stroke={COLORS.lighterGrey} strokeWidth='2'></circle>
          <circle
            cx='17'
            cy='17'
            r='16'
            fill='transparent'
            stroke={COLORS.lightGreen}
            strokeWidth='2'
            strokeDasharray={wins_relative + ' ' + wins_inverse}
            strokeDashoffset='25'></circle>
          <circle
            cx='17'
            cy='17'
            r='16'
            fill='transparent'
            stroke={COLORS.lightRed}
            strokeWidth='2'
            strokeDasharray={defeats_relative + ' ' + defeats_inverse}
            strokeDashoffset={defeats_relative + 25}></circle>
          <g>
            <ChartNumber x='50%' y='50%'>
              {total}
            </ChartNumber>
            <ChartLabel x='50%' y='50%'>
              Spiele
            </ChartLabel>
          </g>
        </SVG>
      </RighttCol>
    </Wrapper>
  );
};

export default MatchesPieChart;
